import { ContributionStatusResponse } from "../model/Contribution";

export const isOnlyWaitingForValidation = (documentsStatus: Record<string, ContributionStatusResponse>): boolean => {
    const onlyOneDocumentToValidate =
        Object.values(documentsStatus).filter((status) => status.status === "VALID" || status.status === "UNKNOWN")
            .length ===
            Object.keys(documentsStatus).length - 1 &&
        Object.values(documentsStatus).filter((status) => status.status === "TO_VALIDATE").length === 1;
    if (!documentsStatus["SIPARE"]) {
        return onlyOneDocumentToValidate;
    }
    const notSipareValid = documentsStatus["SIPARE"].status !== "VALID";
    return onlyOneDocumentToValidate || notSipareValid;
};
